import { responsiveFontSizes } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { dark, light } from './palette';
import shadows from './shadows';

const getTheme = (mode: 'light' | 'dark') =>
  responsiveFontSizes(
    createTheme({
      palette: mode === 'light' ? light : dark,
      shadows: shadows(mode),
      typography: {
        fontFamily: 'Nunito, Inter, system-ui, sans-serif',
        h4: {
          fontWeight: 700,
          fontSize: '2rem',
          color: mode === 'light' ? '#333333' : '#EDEFF2',
        },
        h5: {
          fontWeight: 600,
          fontSize: '1.5rem',
        },
        h6: {
          fontWeight: 600,
          fontSize: '1.25rem',
        },
        body1: {
          fontSize: '1rem',
          color: mode === 'light' ? '#555555' : '#A8ADB8',
        },
        body2: {
          fontSize: '0.875rem',
        },
        button: {
          textTransform: 'none',
        },
      },
      zIndex: {
        appBar: 1200,
        drawer: 1300,
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              fontWeight: 500,
              borderRadius: 8,
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 20,
              paddingRight: 20,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              borderRadius: 8,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 8,
            },
            input: {
              borderRadius: 8,
            },
          },
        },
        MuiCard: {
          styleOverrides: {
            root: {
              borderRadius: 12,
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              borderRadius: 8,
            },
          },
        },
      },
    })
  );

export default getTheme;
